// =======================
// src/paginas/secretaria/sre/CriarSRE.jsx
// =======================

import React from "react";

import FormularioSre from "./FormularioSre";

export default function CriarSRE(props) {
  return <FormularioSre {...props} />;
}
